export function onlyUnique(value: any, index: any, array: string | any[]) {
  return array.indexOf(value) === index;
}

export function checkArraysContainSameElements(arr1: any[], arr2: any[]) {
  return (
    arr1.length === arr2.length &&
    arr1.every((value, index) => value === arr2[index])
  );
}

export function computeMean(arr: number[]) {
  return arr.reduce((a, b) => a + b, 0) / arr.length;
}
